import { globalHive } from '../../src/modules/hive'
import { DS_setData } from '../DS/DS.Data'
import { IDB_dexieDB, IDB_dexieInitialise, IDB_resetAllSyncParams } from './IDB.dexie'
import { IDB_dbName, IDB_initialise } from './IDB.initialise'
import { IDB_indexedDB } from './IDB.polyfill'

export async function IDB_reset() {
    DS_setData('IDBClosed', () => ({ idbConnectionStatus: 'closed' }))

    await Promise.all([
        (async () => {
            // Close the open database connection
            globalHive.db.close()

            // Delete the database
            await new Promise((resolved, reject) => {
                const request = IDB_indexedDB.deleteDatabase(IDB_dbName)
                request.onsuccess = resolved
                request.onerror = reject
            })

            // Open a new connection, creating a new database
            globalHive.db = await IDB_initialise()
        })(),
        (async () => {
            await IDB_dexieDB.delete()
            IDB_dexieInitialise()
            await IDB_resetAllSyncParams()
        })(),
    ])
}
